import { render, staticRenderFns } from "./activity-order.vue?vue&type=template&id=5022ed1c&scoped=true&"
import script from "./activity-order.vue?vue&type=script&lang=js&"
export * from "./activity-order.vue?vue&type=script&lang=js&"
import style0 from "./activity-order.vue?vue&type=style&index=0&id=5022ed1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022ed1c",
  null
  
)

component.options.__file = "activity-order.vue"
export default component.exports